"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Capability Server Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a list of authorized capabilities present in the request body for the userJWT present in the header
     */
    UserApi.prototype.checkUserJWTCapabilitiesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.authorization === null || requestParameters.authorization === undefined) {
                            throw new runtime.RequiredError('authorization', 'Required parameter requestParameters.authorization was null or undefined when calling checkUserJWTCapabilities.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/users/capabilities",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.capabilityID.map(models_1.CapabilityIDToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CapabilityIDFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns a list of authorized capabilities present in the request body for the userJWT present in the header
     */
    UserApi.prototype.checkUserJWTCapabilities = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkUserJWTCapabilitiesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list of authorized capabilities present in the request body for the userJWT present in the header for the given orgID
     */
    UserApi.prototype.checkUserJWTCapabilitiesByOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling checkUserJWTCapabilitiesByOrganization.');
                        }
                        if (requestParameters.authorization === null || requestParameters.authorization === undefined) {
                            throw new runtime.RequiredError('authorization', 'Required parameter requestParameters.authorization was null or undefined when calling checkUserJWTCapabilitiesByOrganization.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/capabilities".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.capabilityID.map(models_1.CapabilityIDToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CapabilityIDFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns a list of authorized capabilities present in the request body for the userJWT present in the header for the given orgID
     */
    UserApi.prototype.checkUserJWTCapabilitiesByOrganization = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkUserJWTCapabilitiesByOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a user in this organization
     */
    UserApi.prototype.createUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling createUser.');
                        }
                        if (requestParameters.user === null || requestParameters.user === undefined) {
                            throw new runtime.RequiredError('user', 'Required parameter requestParameters.user was null or undefined when calling createUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.UserToJSON)(requestParameters.user),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UserFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a user in this organization
     */
    UserApi.prototype.createUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete role assignments for the given user against this organization. Input: roleAssignments [...]
     */
    UserApi.prototype.deleteUserRolesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling deleteUserRoles.');
                        }
                        if (requestParameters.emailID === null || requestParameters.emailID === undefined) {
                            throw new runtime.RequiredError('emailID', 'Required parameter requestParameters.emailID was null or undefined when calling deleteUserRoles.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/{emailID}/roles".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))).replace("{".concat("emailID", "}"), encodeURIComponent(String(requestParameters.emailID))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.roleAssignment.map(models_1.RoleAssignmentToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete role assignments for the given user against this organization. Input: roleAssignments [...]
     */
    UserApi.prototype.deleteUserRoles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteUserRolesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all assigned capabilities for the userJWT present in the request header for the given orgID with optional filter parameters based on service name, and capability metadata key/value pairs(currently supports max 1 key with commma separated corresponding values). If service name is provided, service-name specific userJWT assigned capabilities containing atleast one of the metadata key/value pairs is returned. If service name is not provided, all userJWT assigned capabilities containing atleast one of the metadata key/value pairs is returned.
     */
    UserApi.prototype.getUserJWTCapabilitiesByOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getUserJWTCapabilitiesByOrganization.');
                        }
                        queryParameters = {};
                        if (requestParameters.key !== undefined) {
                            queryParameters['key'] = requestParameters.key;
                        }
                        if (requestParameters.value !== undefined) {
                            queryParameters['value'] = requestParameters.value;
                        }
                        if (requestParameters.service !== undefined) {
                            queryParameters['service'] = requestParameters.service;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/capabilities".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CapabilityFromJSON); })];
                }
            });
        });
    };
    /**
     * Get all assigned capabilities for the userJWT present in the request header for the given orgID with optional filter parameters based on service name, and capability metadata key/value pairs(currently supports max 1 key with commma separated corresponding values). If service name is provided, service-name specific userJWT assigned capabilities containing atleast one of the metadata key/value pairs is returned. If service name is not provided, all userJWT assigned capabilities containing atleast one of the metadata key/value pairs is returned.
     */
    UserApi.prototype.getUserJWTCapabilitiesByOrganization = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserJWTCapabilitiesByOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get roles assigned for the given user against this organization.
     */
    UserApi.prototype.getUserRolesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getUserRoles.');
                        }
                        if (requestParameters.emailID === null || requestParameters.emailID === undefined) {
                            throw new runtime.RequiredError('emailID', 'Required parameter requestParameters.emailID was null or undefined when calling getUserRoles.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/{emailID}/roles".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))).replace("{".concat("emailID", "}"), encodeURIComponent(String(requestParameters.emailID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.roleAssignment.map(models_1.RoleAssignmentToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RoleAssignmentFromJSON); })];
                }
            });
        });
    };
    /**
     * Get roles assigned for the given user against this organization.
     */
    UserApi.prototype.getUserRoles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserRolesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete user by emailID in this organization, i.e. revoke access for this user.
     */
    UserApi.prototype.removeUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling removeUser.');
                        }
                        if (requestParameters.emailID === null || requestParameters.emailID === undefined) {
                            throw new runtime.RequiredError('emailID', 'Required parameter requestParameters.emailID was null or undefined when calling removeUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/{emailID}".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))).replace("{".concat("emailID", "}"), encodeURIComponent(String(requestParameters.emailID))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete user by emailID in this organization, i.e. revoke access for this user.
     */
    UserApi.prototype.removeUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeUserRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get user by emailID in this organization
     */
    UserApi.prototype.retrieveUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling retrieveUser.');
                        }
                        if (requestParameters.emailID === null || requestParameters.emailID === undefined) {
                            throw new runtime.RequiredError('emailID', 'Required parameter requestParameters.emailID was null or undefined when calling retrieveUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/{emailID}".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))).replace("{".concat("emailID", "}"), encodeURIComponent(String(requestParameters.emailID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UserFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user by emailID in this organization
     */
    UserApi.prototype.retrieveUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.retrieveUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of ALL authorized capabilities for this user against given organization.
     */
    UserApi.prototype.retrieveUserCapabilitiesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling retrieveUserCapabilities.');
                        }
                        if (requestParameters.emailID === null || requestParameters.emailID === undefined) {
                            throw new runtime.RequiredError('emailID', 'Required parameter requestParameters.emailID was null or undefined when calling retrieveUserCapabilities.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/{emailID}/capabilities".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))).replace("{".concat("emailID", "}"), encodeURIComponent(String(requestParameters.emailID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CapabilityFromJSON); })];
                }
            });
        });
    };
    /**
     * Get a list of ALL authorized capabilities for this user against given organization.
     */
    UserApi.prototype.retrieveUserCapabilities = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.retrieveUserCapabilitiesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all users in this organization
     */
    UserApi.prototype.retrieveUsersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling retrieveUsers.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.UserFromJSON); })];
                }
            });
        });
    };
    /**
     * Get all users in this organization
     */
    UserApi.prototype.retrieveUsers = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.retrieveUsersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update role assignments for the given user against this organization. Input: roleAssignments [...]
     */
    UserApi.prototype.updateUserRolesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                            throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling updateUserRoles.');
                        }
                        if (requestParameters.emailID === null || requestParameters.emailID === undefined) {
                            throw new runtime.RequiredError('emailID', 'Required parameter requestParameters.emailID was null or undefined when calling updateUserRoles.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{orgID}/users/{emailID}/roles".replace("{".concat("orgID", "}"), encodeURIComponent(String(requestParameters.orgID))).replace("{".concat("emailID", "}"), encodeURIComponent(String(requestParameters.emailID))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.roleAssignment.map(models_1.RoleAssignmentToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RoleAssignmentFromJSON); })];
                }
            });
        });
    };
    /**
     * Update role assignments for the given user against this organization. Input: roleAssignments [...]
     */
    UserApi.prototype.updateUserRoles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserRolesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UserApi;
}(runtime.BaseAPI));
exports.UserApi = UserApi;
